<sbnb-apps-detail-page
  vendorCode="suiteop"
  name="SuiteOp"
  logoTile="/assets/images/apps/suiteop-logo.png"
  builtBy="SuiteOp"
  builtByLink="https://www.suiteop.com/"
  [categories]="['Operations', 'Guest portal', 'Guest verification']"
  [permissions]="[
    AppPermission.propertyListingRead,
    AppPermission.enrichmentRead,
    AppPermission.calendarRead,
    AppPermission.financialsRead,
    AppPermission.enrichmentSmartLockCode
  ]"
  email="support@suiteop.com"
  [beta]="false"
  [helpArticles]="[
    {
      id: '9189677',
      title: 'Connect Hospitable with SuiteOp'
    }
  ]">
  <sbnb-image-carousel
    [images]="[
      '/assets/images/apps/suiteop/analytics.png',
      '/assets/images/apps/suiteop/branding.png',
      '/assets/images/apps/suiteop/dashboard.png',
      '/assets/images/apps/suiteop/guest-portal.png'
    ]"></sbnb-image-carousel>
  <ng-container description>
    <p>
      SuiteOp is a comprehensive operations and guest experience platform designed for short-term rentals, vacation
      rentals, and boutique hotels.
    </p>
    <p>
      With a suite of innovative modules, SuiteOp empowers property managers to streamline operations, enhance the guest
      experience, and optimize their business performance with a single software connected to Hospitable
    </p>
    <div
      class="grid features"
      style="grid-column-gap: 24px; grid-row-gap: 36px"
      [ngClass]="{ 'grid-cols-2': (isMobile$ | async) === false }">
      <div class="flex flex-col" style="gap: 6px">
        <h4>📱 Digital Guidebook</h4>
        <div>The most powerful fully branded digital guidebook.</div>
      </div>
      <div class="flex flex-col" style="gap: 6px">
        <h4>💰 Upsells</h4>
        <div>Generate ancillary revenue and increase your REVPAR.</div>
      </div>
      <div class="flex flex-col" style="gap: 6px">
        <h4>🪪 ID Verification</h4>
        <div>Powerful guest verification tools to reduce chargebacks.</div>
      </div>
      <div class="flex flex-col" style="gap: 6px">
        <h4>📝 Fees, Agreements, and Security Deposits</h4>
        <div>Create custom fees and collect digital agreements.</div>
      </div>
      <div class="flex flex-col" style="gap: 6px">
        <h4>🔓 Smart Device Management</h4>
        <div>Integrate with any smart lock for keyless entry, benefit from energy-saving thermostat integrations.</div>
      </div>
      <div class="flex flex-col" style="gap: 6px">
        <h4>🦾 Task Management</h4>
        <div>Centralized maintenance and housekeeping functions in one unified operational system.</div>
      </div>
      <div class="flex flex-col" style="gap: 6px">
        <h4>🔊 Noise & Occupancy Monitoring</h4>
        <div>Protect your asset and prevent unwanted parties and noise complaints.</div>
      </div>
      <div class="flex flex-col" style="gap: 6px">
        <h4>📊 Operations Analytics</h4>
        <div>Operations and AI-powered guest review analytics.</div>
      </div>
    </div>

    <p>
      SuiteOp's 2-way integration to Hospitable makes onboarding a breeze. Hospitable users enjoy an end-to-end
      white-glove onboarding, and guarantees a full setup with SuiteOp within a day.
    </p>
    <p>Discover the advantages of SuiteOp's centralized solution and elevate your property management operation now.</p>
  </ng-container>
</sbnb-apps-detail-page>
